<template>
    <footer><slot></slot></footer>
</template>
<script>

export default {
  name: "m-footer",
};
</script>